// Hidden contact endpoints - email is base64-encoded so the raw address
// isn't visible in view-source. Phone stays public (business line).
// Decoded on click; opens the user's default mail / SMS app.

const OWNER_EMAIL_B64 = "Y29udGFjdEBzdHJpdmVtb3RvcnNmbC5jb20=";
const OWNER_PHONE = "+15615026769";

const decode = (b64) => {
  try {
    return typeof window === "undefined" ? "" : window.atob(b64);
  } catch {
    return "";
  }
};

export const openEmail = ({ subject, body, cc } = {}) => {
  if (typeof window === "undefined") return;
  const addr = decode(OWNER_EMAIL_B64);
  const params = new URLSearchParams();
  if (cc) params.set("cc", cc);
  if (subject) params.set("subject", subject);
  if (body) params.set("body", body);
  const qs = params.toString();
  window.location.href = `mailto:${addr}${qs ? `?${qs}` : ""}`;
};

export const openSMS = ({ body } = {}) => {
  if (typeof window === "undefined") return;
  const q = body ? `?&body=${encodeURIComponent(body)}` : "";
  // sms: scheme - Android uses ?body= , iOS uses &body= - dual "?&" works widely.
  window.location.href = `sms:${OWNER_PHONE}${q}`;
};
